export const countryCodes = [
  { code: '+44', country: 'GB', label: 'United Kingdom' },
  { code: '+1', country: 'US', label: 'United States' },
  { code: '+353', country: 'IE', label: 'Ireland' },
  { code: '+61', country: 'AU', label: 'Australia' },
  { code: '+64', country: 'NZ', label: 'New Zealand' },
  { code: '+1', country: 'CA', label: 'Canada' },
  { code: '+91', country: 'IN', label: 'India' },
  { code: '+27', country: 'ZA', label: 'South Africa' },
  { code: '+971', country: 'AE', label: 'UAE' },
  { code: '+966', country: 'SA', label: 'Saudi Arabia' },
  { code: '+65', country: 'SG', label: 'Singapore' },
  { code: '+852', country: 'HK', label: 'Hong Kong' },
  { code: '+60', country: 'MY', label: 'Malaysia' },
  { code: '+49', country: 'DE', label: 'Germany' },
  { code: '+33', country: 'FR', label: 'France' },
  { code: '+34', country: 'ES', label: 'Spain' },
  { code: '+39', country: 'IT', label: 'Italy' },
  { code: '+31', country: 'NL', label: 'Netherlands' },
  { code: '+46', country: 'SE', label: 'Sweden' },
  { code: '+47', country: 'NO', label: 'Norway' },
  { code: '+45', country: 'DK', label: 'Denmark' },
  { code: '+41', country: 'CH', label: 'Switzerland' },
  { code: '+48', country: 'PL', label: 'Poland' },
  { code: '+351', country: 'PT', label: 'Portugal' },
  { code: '+30', country: 'GR', label: 'Greece' },
  { code: '+81', country: 'JP', label: 'Japan' },
  { code: '+82', country: 'KR', label: 'South Korea' },
  { code: '+86', country: 'CN', label: 'China' },
  { code: '+55', country: 'BR', label: 'Brazil' },
  { code: '+52', country: 'MX', label: 'Mexico' },
  { code: '+234', country: 'NG', label: 'Nigeria' },
  { code: '+254', country: 'KE', label: 'Kenya' },
  { code: '+20', country: 'EG', label: 'Egypt' },
  { code: '+92', country: 'PK', label: 'Pakistan' },
  { code: '+880', country: 'BD', label: 'Bangladesh' },
  { code: '+94', country: 'LK', label: 'Sri Lanka' },
  { code: '+63', country: 'PH', label: 'Philippines' },
  { code: '+66', country: 'TH', label: 'Thailand' },
  { code: '+84', country: 'VN', label: 'Vietnam' },
  { code: '+62', country: 'ID', label: 'Indonesia' },
  { code: '+90', country: 'TR', label: 'Turkey' },
  { code: '+972', country: 'IL', label: 'Israel' },
  { code: '+7', country: 'RU', label: 'Russia' },
  { code: '+380', country: 'UA', label: 'Ukraine' },
  { code: '+43', country: 'AT', label: 'Austria' },
  { code: '+32', country: 'BE', label: 'Belgium' },
  { code: '+358', country: 'FI', label: 'Finland' },
  { code: '+420', country: 'CZ', label: 'Czech Republic' },
  { code: '+36', country: 'HU', label: 'Hungary' },
  { code: '+40', country: 'RO', label: 'Romania' },
];

export const flagEmoji = (countryCode: string) => {
  return countryCode
    .toUpperCase()
    .split('')
    .map(c => String.fromCodePoint(0x1F1E6 + c.charCodeAt(0) - 65))
    .join('');
};
